export const LOAD_CORPORATE_NEEDS_SUCCESS = "LOAD_CORPORATE_NEEDS_SUCCESS";
export const LOAD_CORPORATE_NEED_SUCCESS = "LOAD_CORPORATE_NEED_SUCCESS";
export const LOAD_CORPORATE_NEED_LOADING = "LOAD_CORPORATE_NEED_LOADING";
export const LOAD_CORPORATE_NEED_FAILED = "LOAD_CORPORATE_NEED_FAILED";
